/**
 * The master settings page for the AGWA tenant.
 *
 * @remarks
 * This component serves as the main entry point for tenant-level system settings in the AGWA application.
 * It encompasses user management for the tenant themselves, as well as member group management and other
 * system-wide configuration options.
 *
 * The page is structured with a vertical tab navigation, starting with user management, and is designed
 * to be extended with additional settings sections as needed.
 *
 * @slot - Renders the content for the selected settings tab.
 *
 * @csspart system-settings - The main container for the system settings page.
 * @csspart settings-layout - The layout wrapper for the navigation and content.
 * @csspart tabs-vertical - The vertical navigation tabs.
 * @csspart tab-content - The content area for the selected tab.
 */
import { LitElement, html, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import styles from './system-settings-styles.css?inline';
import { WithUserProfileConsumer } from '../../../mixins/with-user-profile-consumer';
import '../../../components/under-construction';

// Staff management temporarily disabled; showing under construction message.

@customElement('system-settings')
export class SystemSettings extends WithUserProfileConsumer(LitElement) {
  static styles = [unsafeCSS(styles)];

  // Staff management removed; placeholder only.

  render() {
    return html` <under-construction></under-construction> `;
  }
}
